import { useEffect, useState } from 'react';
import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

const themes = defineTheme({
  filter: 'background-hover-effect--filter-color',
  menu: 'background-hover-effect--menu-color'
});
export type BackgroundHoverEffectTheme = ThemeKeys<typeof themes>;

interface IBackgroundHoverEffectProps {
  theme?: BackgroundHoverEffectTheme;
  enable?: boolean;
  parentToCover: HTMLElement | null;
  children: React.ReactNode;
}

const BackgroundHoverEffect: React.FC<IBackgroundHoverEffectProps> = ({ children, parentToCover, enable, theme }) => {
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (parentToCover) {
      const height = parentToCover.offsetHeight;
      const paddingBottom = Number(
        window.getComputedStyle(parentToCover).getPropertyValue('padding-bottom').slice(0, -2) //remove "px"
      );
      const borderBottom = 1;
      const borderTop = 1;

      setStyle({
        height: height + borderTop,
        marginTop: `${paddingBottom + borderBottom}px`
      });
    }
  }, [parentToCover]);
  return (
    <>
      <div className="background-hover-effect__trigger">{children}</div>
      {enable && <div className={cn('background-hover-effect', themes(theme))} style={style}></div>}
    </>
  );
};

BackgroundHoverEffect.displayName = 'BackgroundHoverEffect';

export default BackgroundHoverEffect;
